module.exports = __webpack_public_path__ + "img/应用场景_集团会议.f673c9f9.png";